import { useEffect } from "react";

import { ArrowRight } from "lucide-react";
import "../about-online-trading/index.css";
import img from "../../assets/images/vtrade.png";
import PdfPage from "../../components/PdfPage";
import PSX from "../../assets/images/psx.png";

export default function DownloadTradingApps() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
        }
      });
    }, observerOptions);

    document.querySelectorAll(".animate").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div style={{ overflowX: 'hidden'}} className="platform-container">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text animate">
            <h1>
              VTRADE
              <span className="gradient-text">
                Your easily accessible source to PSX
              </span>
            </h1>
            <p className="hero-subtitle">
              With Vtrade Online Trading you have direct access to Pakistan
              Stock Exchange, real-time tools and resources, mobile trading
              platforms and fully-integrated account options which as a whole,
              take the complexity out of trading.
            </p>
            <div className="hero-buttons">
              <a href="/create-account" className="cta-button">
                Start Trading Now
                <ArrowRight size={20} />
              </a>
              <a href="/psx-investor-guide" className="demo-button">
                Learn More
              </a>
            </div>
          </div>
          {/* <div className="hero-image animate">
              <div className="laptop-container">
                <img
                  src={img}
                  alt="Trading Platform Interface"
                  width={600}
                  height={400}
                  className="laptop-screen"
                />
                <div className="reflection"></div>
              </div>
            </div> */}
        </div>
      </section>
      <div className="main-container-apps">
        <PdfPage
          h2={"Online Trading"}
          img={PSX}
          pdf1={"/img/launch.jnlp"}
          pdf1Text={"KITS PSX Download"}
          pdf2={"/img/jre-8u421-windows.exe"}
          pdf2Text={"JAVA Download"}
        />
      </div>

      <section className="cta-section animate">
        <div className="cta-content">
          <h2>Welcome to Pakistan Stock Exchange</h2>
          <p>
            Download our mobile trading platform and access the market anywhere,
            anytime
          </p>
          <div className="download-buttons">
            <a href="/img/Vtrade-Setup.exe" className="store-button">
              <i className="fab fa-windows"></i>
              <div>
                <span>GET IT ON</span>
                <strong>Windows</strong>
              </div>
            </a>
            <a href="/coming-soon" className="store-button">
              <i className="fab fa-google-play"></i>
              <div>
                <span>GET IT ON</span>
                <strong>Google Play</strong>
              </div>
            </a>
            <a href="/coming-soon" className="store-button">
              <i className="fab fa-apple"></i>
              <div>
                <span>Download on the</span>
                <strong>App Store</strong>
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
